import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog'
import { BehaviorSubject } from 'rxjs'
import { switchMap, tap } from 'rxjs/operators'
import { SubSink } from 'subsink'

import { TaxCodeLookupDialog } from '../../dialogs/tax-code-lookup/tax-code-lookup.dialog'
import { ITaxCode } from '../../models/itax-code.model'
import { TaxCodeService } from '../../services/tax-code.service'

@Component({
  selector: 'tc-tax-code-select',
  templateUrl: './tax-code-selector.component.html',
  styleUrls: ['./tax-code-selector.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxCodeSelectorComponent implements OnInit, OnDestroy {
  sub = new SubSink()
  form: UntypedFormGroup
  ticId = new UntypedFormControl()
  selected$ = new BehaviorSubject<ITaxCode>(null)

  constructor(
    private taxCodeService: TaxCodeService,
    private fb: UntypedFormBuilder,
    public dialog: MatDialog
  ) {
    this.form = fb.group({
      ticId: this.ticId,
    })

    this.sub.add(taxCodeService.updateIfNecessary().subscribe())
  }

  @Input('ticId')
  set setTicId(ticId: number) {
    this.ticId.setValue(ticId)
  }

  @Output() ticChanges = new EventEmitter<ITaxCode | null>()

  ngOnInit(): void {
    this.sub.add(
      this.ticId.valueChanges
        .pipe(
          switchMap((ticId) => this.taxCodeService.getTaxCode(parseInt(ticId, 10))),
          tap((tic: ITaxCode) => {
            if (!tic) {
              this.ticId.setErrors({ invalidTicId: true })
              this.selected$.next(null)
              this.ticChanges.emit(null)
            } else {
              this.selected$.next(tic)
              this.ticChanges.emit(tic)
            }
          })
        )
        .subscribe()
    )

    // TODO fix async issue
    setTimeout(() => {
      this.form.patchValue({ ticId: this.ticId.value })
    }, 0)
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

  openTaxCodeSearchDialog(): void {
    const dialogRef = this.dialog.open(TaxCodeLookupDialog, {
      panelClass: 'confirm-dialog',
      restoreFocus: false,
    })

    dialogRef.afterClosed().subscribe((dialog) => {
      if (!dialog || dialog.result < 0) {
        return
      }

      const tic = dialog.result as ITaxCode

      if (tic && tic.ticId) {
        this.ticId.setValue(tic.ticId)
      }
    })
  }
}
